import React from 'react'
import { observer } from 'mobx-react'
import ModelContext from '../contexts/ModelContext'
import useCollector from '../hooks/use-collector'

function CollectorToModel (props) {
  const collector = useCollector()

  if (collector === null) {
    throw new Error('Tried to provide model from collector, but NULL was provided.')
  }

  return (
    <ModelContext.Provider value={collector.model}>
      {props.children}
    </ModelContext.Provider>
  )
}

export default observer(CollectorToModel)
